module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layout-page"
  }, [_c('div', {
    attrs: {
      "id": "header"
    }
  }, [_vm._t("header", [_c('div', {
    staticClass: "sample-content"
  }, [_vm._l((50), function(n) {
    return [_vm._v("Header ")]
  })], 2)])], 2), _vm._v(" "), _c('div', {
    staticClass: "layout-content",
    style: (_vm.contentStyle)
  }, _vm._l((_vm.columnList), function(column, index) {
    return _c('div', {
      key: index,
      staticClass: "layout-column",
      style: ({
        'flex-basis': column.width
      }),
      attrs: {
        "id": 'col' + (index + 1)
      }
    }, [_c('div', {
      staticClass: "layout-column-padder"
    }, [_vm._t('col' + (index + 1), [_c('div', {
      staticClass: "sample-content"
    }, [_vm._l((400), function(n) {
      return [_vm._v("Column " + _vm._s(index) + " ")]
    })], 2)])], 2)])
  }), 0), _vm._v(" "), _c('div', {
    attrs: {
      "id": "footer"
    }
  }, [_vm._t("footer", [_c('div', {
    staticStyle: {
      "height": "15px"
    }
  })])], 2), _vm._v(" "), _c('div', {
    attrs: {
      "id": "dialogs"
    }
  }, [_vm._t("dialogs")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a8907b0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/LayoutContainer.vue
// module id = 2509
// module chunks = 1